import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProductLabelComponent} from './product-label/product-label.component';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {TranslateModule} from '@ngx-translate/core';
import {ProductLabelsComponent} from './product-labels.component';
import {LabelComponent} from '@app/presentation/components/label/label.component';


@NgModule({
  declarations: [
    ProductLabelsComponent,
    ProductLabelComponent
  ],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    TranslateModule,
    LabelComponent,
  ],
  exports: [
    ProductLabelsComponent
  ]
})
export class ProductLabelsModule { }
